import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';
import { _x } from '@wordpress/i18n';

const a11yConfig = {
  firstSlideMessage: _x(
    'This is the first slide',
    'carousel first slide label',
    'vtx'
  ),
  lastSlideMessage: _x(
    'This is the last slide',
    'carousel last slide label',
    'vtx'
  ),
  prevSlideMessage: _x('Previous slide', 'carousel previous label', 'vtx'),
  nextSlideMessage: _x('Next slide', 'carousel next label', 'vtx'),
};

domReady(() => {
  document.querySelectorAll('.why-us-carreer-block').forEach((block) => {
    if ('carousel' !== block.dataset.mode) {
      return;
    }

    const textEl = block.querySelector('.why-us-carreer-block__text-swiper');
    const bgEl = block.querySelector('.why-us-carreer-block__bg-swiper');

    if (!textEl || !bgEl) {
      return;
    }

    const controlsEl = block.querySelector('.why-us-carreer-block__controls');
    const paginationEl = block.querySelector(
      '.why-us-carreer-block__pagination'
    );

    const bgSwiper = new Swiper(bgEl, {
      slidesPerView: 1,
      effect: 'fade',
      fadeEffect: { crossFade: true },
      rewind: true,
      allowTouchMove: false,
      a11y: a11yConfig,
    });

    new Swiper(textEl, {
      slidesPerView: 1,
      effect: 'fade',
      fadeEffect: { crossFade: true },
      rewind: true,
      controller: {
        control: bgSwiper,
      },
      navigation: {
        prevEl: controlsEl
          ? controlsEl.querySelector('.swiper-button-prev')
          : null,
        nextEl: controlsEl
          ? controlsEl.querySelector('.swiper-button-next')
          : null,
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      a11y: a11yConfig,
    });
  });
});
